import React, { Component } from 'react'
import Swipeable from 'react-swipeable'
import '../styles/css/ImageViewer.css'

export default class ImageViewer extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            images: [],
            currentImage: 0
        }
    }

    componentDidMount = () => {
        const { images, currentImage } = this.props
        this.setState({
            images,
            currentImage
        })
        window.addEventListener("keydown", this.handleKey, true);
        document.body.addEventListener('touchmove', this.preventDefault, { passive: false });
    }

    componentWillUnmount = () => {
        window.removeEventListener("keydown", this.handleKey)
        document.body.removeEventListener('touchmove', this.preventDefault, { passive: false });
    }

    onCancel = () => {
        this.props.onCancel()
    }

    nextImage = () => {
        const { images, currentImage } = this.state
        this.setState({
            currentImage: currentImage < images.length - 1 ? currentImage + 1 : 0,
            loading: true
        })
    }

    prevImage = () => {
        const { images, currentImage } = this.state
        this.setState({
            currentImage: currentImage > 0 ? currentImage - 1 : images.length - 1,
            loading: true
        })
    }

    handleKey = ({ keyCode }) => {
        if(keyCode === 39) {
            this.nextImage()
        } else if(keyCode === 37) {
            this.prevImage()
        } else if(keyCode === 27) {
            this.onCancel()
        }
    }

    onImageLoad = () => {
        this.setState({
            loading: false
        })
    }

    preventDefault = e => {
        e.preventDefault()
    }

    render() {
        const { currentImage } = this.state
        const { images= [] } = this.props
        return(
                <div id="imageViewer" className="image-viewer">
                    <div className="image-viewer-inner">
                         
                        <button className="close" onClick={this.onCancel}><span></span><span></span></button>
                        <button className="nav prev" onClick={this.prevImage}></button>
                        <button className="nav next" onClick={this.nextImage}></button>

                        <div className="image-viewer-content">
                                <div className="image-viewer-container">
                                    {this.state.loading && <div className="loader"></div>}
                                    <Swipeable onSwipedLeft={this.nextImage} onSwipedRight={this.prevImage} trackMouse>
                                        <img
                                            className={this.state.loading ? 'hide-image' : ''} 
                                            src={images[currentImage].images.large}
                                            onLoad={this.onImageLoad} 
                                            key={this.state.currentImage}
                                        />
                                    </Swipeable>
                                </div>
                        </div>

                    </div>
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ImageViewer.js